module.exports = __webpack_public_path__ + "img/muying1.49c618b3.png";